import type { ReactNode } from "react";
import { Badge } from "./Badge";
import type { Player } from "./contracts";
import { cx, stagger } from "./util";

export interface PlayerRowProps {
  player: Player;
  /** Highlights the row belonging to the device you are holding. */
  isSelf?: boolean;
  /** Stagger index for the list entrance. */
  index?: number;
  /** Phase-scoped "done" state: covered in the lobby, voted in voting. */
  ready?: boolean;
  readyLabel?: string;
  /** Right-hand slot: a donate button, a score, upload progress. */
  children?: ReactNode;
}

export function PlayerRow({
  player,
  isSelf = false,
  index = 0,
  ready,
  readyLabel = "Ready",
  children,
}: PlayerRowProps) {
  const isReady = ready ?? player.covered;

  return (
    <div
      className={cx("row", isSelf && "row-highlight", !player.connected && "bd-offline")}
      style={stagger(index)}
    >
      <span className="t-link grow truncate">
        {player.name}
        {isSelf ? <span className="t-micro muted"> (you)</span> : null}
      </span>

      {player.isHost ? <Badge tone="host">Host</Badge> : null}
      {player.needClip && !player.covered ? <Badge tone="amber">Needs a clip</Badge> : null}
      {isReady ? (
        <Badge tone="ready" animate>
          {readyLabel}
        </Badge>
      ) : null}
      {!player.connected ? <Badge tone="carbon">Offline</Badge> : null}

      {children}
    </div>
  );
}
